// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"6364856f","211":"6364856f","728":"abaa2d81","770":"6364856f","811":"6364856f"}[chunkId] + ".chunk.css";
};